import React from 'react';
import styled from '@emotion/styled';
import { Flex, Stack } from '@atlaskit/primitives';
import { N0, N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { FormattedDate } from '@css-xp/base';
import { NEW_DATE_TIME_FORMAT } from '@atlassian/cssxp-typescommon';
import type { TooltipComponentProps } from '@atlassian/old-usage-graph';

const TooltipWrapper = styled.div({
  backgroundColor: token('color.background.input', N0),
  borderRadius: token('border.radius.100', '3px'),
  boxShadow: token(
    'elevation.shadow.raised',
    '0px 3px 5px 0px rgba(9, 30, 66, 0.20), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)'
  ),
  boxSizing: 'border-box',
  padding: token('space.200', '16px'),
  width: '220px',
});

const TooltipDateField = styled.div({
  fontSize: '12px',
  color: token('color.text.subtlest', N200),
  fontWeight: 600,
});

const TooltipFieldLabel = styled.div({
  fontSize: '12px',
});

const TooltipFieldValue = styled.div({
  fontSize: '12px',
  fontWeight: 600,
});

const TooltipHwmDescription = styled.div({
  fontSize: '10px',
  color: token('color.text.subtlest', N200),
});

export const UserHistoryGraphTooltip: React.ComponentType<TooltipComponentProps> = ({
  datapoint: { highWatermark, timestamp, maximumUsage, isHighWatermark },
}) => {
  const maxBillableUsers = highWatermark ? highWatermark : maximumUsage;
  return (
    <TooltipWrapper>
      <Stack space="space.150">
        <TooltipDateField>
          <FormattedDate date={timestamp.toString()} showTime={true} format={NEW_DATE_TIME_FORMAT} />
        </TooltipDateField>
        <Stack space="space.050">
          <Flex alignItems="center" justifyContent="space-between">
            <TooltipFieldLabel>Maximum billable usage</TooltipFieldLabel>
            <TooltipFieldValue>{maxBillableUsers}</TooltipFieldValue>
          </Flex>
          <Flex alignItems="center" justifyContent="space-between">
            <TooltipFieldLabel>User count</TooltipFieldLabel>
            <TooltipFieldValue>{maximumUsage}</TooltipFieldValue>
          </Flex>
        </Stack>
        {isHighWatermark ? (
          <TooltipHwmDescription>A prorated cost for new users will be added to your next bill.</TooltipHwmDescription>
        ) : null}
      </Stack>
    </TooltipWrapper>
  );
};
